import { render } from "./IndexKitchen.vue?vue&type=template&id=4c9cbdf8"
import script from "./IndexKitchen.vue?vue&type=script&lang=js"
export * from "./IndexKitchen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__